import { toast } from '../Toast/Toast'

type AssignTrainingsMutationData = {
  assignTrainings?: {
    applicantTrainingsIds?: string[] | null
    applicantCoursesIds?: string[] | null
    errors?: Array<{
      trainingId?: string | null
      courseId?: string | null
      errorMsg: string
    }> | null
  } | null
}

export const handleAssignTrainingsCompleted = (
  data: AssignTrainingsMutationData,
  close: () => void,
  // courseId/trainingId -> display name, so failures name what failed.
  labelById?: Record<string, string>
) => {
  const result = data?.assignTrainings
  const errors = result?.errors ?? []
  const successCount =
    (result?.applicantTrainingsIds?.length ?? 0) +
    (result?.applicantCoursesIds?.length ?? 0)

  if (errors.length > 0) {
    const msg = errors
      .map((e) => {
        const id = e.courseId ?? e.trainingId ?? undefined
        const label = id ? labelById?.[id] : undefined
        return label ? `${label}: ${e.errorMsg}` : e.errorMsg
      })
      .join('; ')
    if (successCount === 0) {
      toast(msg, 'error')
      return
    }
    toast(msg, 'warning')
  }

  close()
}
